const SAFE_ALPHABET = '234679ACDEFGHJKMNPQRTUVWXY';
const SAFE_BASE = SAFE_ALPHABET.length;

/**
 * Zamienia liczbę na string w bezpiecznym alfabecie.
 */
function encodeSafeBase(n: number): string {
    let result = '';
    do {
        result = SAFE_ALPHABET[n % SAFE_BASE] + result;
        n = Math.floor(n / SAFE_BASE);
    } while (n > 0);
    return result;
}

/**
 * Odtwarza liczbę z bezpiecznego stringa.
 */
function decodeSafeBase(s: string): number {
    return s.replaceAll('-', '').split('').reduce((acc, char) => acc * SAFE_BASE + SAFE_ALPHABET.indexOf(char), 0);
}

/**
 * Oblicza znak kontrolny.
 */
function calculateSafeChecksum(input: string): string {
    const sum = input.split('').reduce((acc, char) => acc + SAFE_ALPHABET.indexOf(char), 0);
    return SAFE_ALPHABET[sum % SAFE_BASE];
}

/**
 * Generuje bezpieczny ID (czytelny, z checksumem).
 */
export function generateRefId(): string {
    const timestamp = Date.now();
    const encoded = encodeSafeBase(timestamp).padStart(8, SAFE_ALPHABET[0]);
    const checksum = calculateSafeChecksum(encoded);
    const raw = `${encoded}${checksum}`;
    return raw.length <= 8
        ? raw
        : `${raw.slice(0, 3)}-${raw.slice(3, 7)}-${raw.slice(7)}`;
}

/**
 * Parsuje i weryfikuje bezpieczny ID.
 */
export function decodeDateFromRefId(id: string): Date {
    const body = id.slice(0, -1);
    const checksum = id.slice(-1);
    const expected = calculateSafeChecksum(body);
    if (checksum !== expected) {
        throw new Error('Invalid checksum');
    }
    const timestamp = decodeSafeBase(body);
    return new Date(timestamp);
}
